module.exports = __webpack_public_path__ + "static/img/IE.582bfde7.jpg";